import { useEffect, useState, useRef } from 'react';
import LoadingPage from "../components/Loading";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchEventById } from '../services/events.js'
import { fetchRegistrationFormTemplateById } from '../services/registrationFormTemplates.js';
import { insertRegistrationForm } from '../services/registrationForms.js'

import DownArrow from '../svgs/DownArrow.js';
import CompleteSvg from '../svgs/CompleteSvg.js';
import { loginWithEmailOtp, registerWithEmail, requestOtpWithEmail, uploadNewUserProfile } from "../services/users.js";
import { participateEvent, checkIfEmailRegisteredEvent } from "../services/events.js";
import { uploadCV } from '../services/documents.js';

const Page = ({ scrollRef, handleSetRightNav }) => {
    const eventId = '6953936089f8f6bd1a75d777'
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const navigate = useNavigate();

    async function fetchDate() {
        setisloading(true)
        let result = await fetchEventById(eventId);
        if (result?.result) {
            setData(result.result);
        } else {
            setData({});
            alert('無法獲取報名表資料，請稍後再試。')
        }
        setisloading(false)
    }
    useEffect(() => {
        if (eventId.length === 24) {
            fetchDate()
        }
    }, [eventId])

    const isMobile = window?.innerWidth < 768
    const handleBack = () => {
        window?.ReactNativeWebView?.postMessage('close')
        navigate(-1)
    }
    const [type, setType] = useState('individual') // individual or group

    return (
        <div className='w-full flex-col items-center relative'>

            {/* A sliding buttons for switching between individual and group registration */}
            <div className='w-full flex items-center justify-center mt-[24px] mb-[16px]'>
                <div className='flex flex-row bg-[#F0EDE5] rounded-full p-[4px] shadow-md'>
                    <div className={`cursor-pointer px-[16px] py-[8px] rounded-full font-bold ${type === 'individual' ? 'bg-[#000000] text-white' : 'text-[#000000]'}`} onClick={() => setType('individual')}>
                        個人報名 Individual
                    </div>
                    <div className={`cursor-pointer px-[16px] py-[8px] rounded-full font-bold ${type === 'group' ? 'bg-[#000000] text-white' : 'text-[#000000]'}`} onClick={() => setType('group')}>
                        合作咨詢 Inquiry
                    </div>
                </div>
            </div>

            {type === 'individual' ?
                <IndividualForm
                    allowRegistration={data?.registrationForm?.enable || false}
                    form={data?.registrationForm || {}}
                    id={eventId}
                /> : <GroupForm />}
            {isloading && <LoadingPage />}

            {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
            {/* {isMobile&&
            <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>} */}
        </div>
    );
};






const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}


const AGE = ['18-25', '26-29', '30-35', '36-49', '50-60', '60+']
const EDU = ['學士 Bachelor', '碩士 Master', '博士 Doctor', '其他 Other']
const WORKEX = [
    '應屆畢業生 Fresh graduates',
    '1-2年工作經驗 working experience',
    '3-5年工作經驗 working experience',
    '6-9年工作經驗 working experience',
    '10年及以上工作經驗 working experience'
]
const VISA = [
    '香港本地永久居民 Hong Kong Permanent Resident',
    '優秀人才入境計劃 Quality Migrant AdmissionScheme',
    '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
    '一般就業政策（外籍專才）General Employment Policy',
    '高端人才通行證計劃 Top Talent Pass Scheme',
    '科技人才入境計劃 Technology Talent Admission Scheme',
    '在讀學生 Student Visa',
    '非本地畢業生留港/回港計劃 IANG Visa',
    '澳門居民 Macao Resident',
    '內地居民 Mainland Resident',
    '其他國家身份 Resident of other countries',
    // '優秀人才入境計劃 Quality Migrant AdmissionScheme',
    // '輸入內地人才計劃 Admission Scheme for Mainland Talents and Professionals',
    // '一般就業政策（外籍專才）General Employment Policy',
    // '高端人才通行證計劃 Top Talent Pass Scheme',
    // '科技人才入境計劃 Technology Talent Admission Scheme',
    // '非本地畢業生留港/回港計劃 IANG Visa',
    // '在讀學生簽證 Student Visa',
    // '受養人簽證 Dependant',
    // '通過人才計劃來港已永久 HK Permanent Resident',
    // '香港本地專業人士 HK Native Professionals',
    // '計劃申請香港人才計劃中 Apply',
    // '其他 Other'
]


const IndividualForm = (props) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const showTable = searchParams.get('showTable') === 'true' || false
    const vipPackage = searchParams.get('vipPackage') || null
    const form = props.form || {};
    const [isloading, setisloading] = useState(false);
    const ref1 = useRef(null)
    const ref2 = useRef(null)
    const ref3 = useRef(null)
    const ref4 = useRef(null)
    const ref5 = useRef(null)
    const ref6 = useRef(null)
    const [num1, setnum1] = useState('')
    const [num2, setnum2] = useState('')
    const [num3, setnum3] = useState('')
    const [num4, setnum4] = useState('')
    const [num5, setnum5] = useState('')
    const [num6, setnum6] = useState('')
    const [countdown, setcountdown] = useState(0)

    const [isVerified, setisVerified] = useState(false)
    const [isShowOtpPopup, setisShowOtpPopup] = useState(false)
    const [data, setData] = useState({
        isRegisterTgather: true
    })
    const onChangeEmail = (e) => { setData({ ...data, email: e.target.value?.toLowerCase() }) }
    const onChangeMobile = (e) => { setData({ ...data, mobile: e.target.value }) }
    const onChangeDegree = (e) => { setData({ ...data, degree: e.target.value }) }
    const onChangefirstname = (e) => { setData({ ...data, firstname: e.target.value }) }
    const onChangelastname = (e) => { setData({ ...data, lastname: e.target.value }) }
    const onChangeenglishName = (e) => { setData({ ...data, englishName: e.target.value }) }
    const onChangecompany = (e) => { setData({ ...data, company: e.target.value }) }
    const onChangeSchoolMajor = (e) => { setData({ ...data, school: e.target.value }) }
    const onChangeWechat = (e) => { setData({ ...data, wechat: e.target.value }) }
    const onChangePosition = (e) => { setData({ ...data, position: e.target.value }) }
    const onChangeTitle = (e) => { setData({ ...data, title: e.target.value }) }
    const onChangeEmployer = (e) => { setData({ ...data, employer: e.target.value }) }
    const onChangeGraduationTime = (e) => { setData({ ...data, graduationTime: e.target.value }) }
    useEffect(() => {
        console.log(data)
    }, [data])

    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() { const { innerWidth, innerHeight } = window; return { innerWidth, innerHeight }; }
    useEffect(() => {
        function handleWindowResize() { setWindowSize(getWindowSize()); }
        window.addEventListener('resize', handleWindowResize);
        return () => { window.removeEventListener('resize', handleWindowResize); };
    }, [])

    const [showRegisterError, setshowRegisterError] = useState('')
    const onRequestOtp = async () => {
        if (isVerified) return
        if (!validateEmail(data?.email)) {
            alert('電子郵件無效，請重新輸入');
            return
        }
        setisloading(true)
        let checkEmail = await checkIfEmailRegisteredEvent(props.id, data.email)
        if (checkEmail.errno) {
            alert(checkEmail.message || 'error')
            setisloading(false)
            return
        }
        if (checkEmail?.result !== false) {
            // let eventParticipation = checkEmail?.result
            // if(eventParticipation?.data?.isRequirePayment&&!eventParticipation?.data?.isPaid){
            //     alert('該郵箱已經登記過，但尚未完成付款，請前往付款。')
            //     navigate(`/purchase/${eventParticipation?.data?.vipPackage||''}?userid=${eventParticipation.userId||''}`)
            //     return
            // }
            // if(eventParticipation?.data?.isRequirePayment&&eventParticipation?.data?.isPaid){
            //     alert('該郵箱已經登記過，並已完成付款，如需更改登記資料，請聯絡我們。')
            //     return
            // }
            setshowRegisterError('該郵箱已經登記過，如用同一信箱登記，將覆蓋您原先的登記信息，如確認修改，請繼續填寫。')
        } else {
            setshowRegisterError('')
        }

        let result = await requestOtpWithEmail(data.email)
        if (result.errno) {
            alert(`${result?.message}||Error (70001)`);
            setisloading(false)
            return
        }
        setisShowOtpPopup(true)
        setisVerified(false)
        setcountdown(120)
        setisloading(false)
    }
    const cancelOtp = () => {
        setisShowOtpPopup(false)
        setisVerified(false)
        setData({ ...data, token: null });
        setnum1(''); setnum2(''); setnum3(''); setnum4(''); setnum5(''); setnum6('');
    }


    const handleLoginButton = async () => {
        const otp = `${num1}${num2}${num3}${num4}${num5}${num6}`
        if ((!otp) || otp.length !== 6) { alert('驗證碼無效，請重新輸入'); return; }

        setisloading(true)
        try {
            setisloading(true)
            let res = await loginWithEmailOtp(data.email, otp)
            if (res.errno) {
                alert(res.message || '驗證碼無效，請重新輸入');
                setisloading(false)
                return
            }

            let token = res?.token?.token
            setData({ ...data, token });

            setisShowOtpPopup(false)
            setisVerified(true)
            setnum1(''); setnum2(''); setnum3(''); setnum4(''); setnum5(''); setnum6('');
            setisloading(false)


        } catch (e) {
            console.log(e)
            alert(e.message)
        } finally {
            setisloading(false)
        }
    }
    const [userId, setuserId] = useState(null)
    useEffect(() => {
        if (data?.token) {
            let tokenPayload = parseJwt(data?.token)
            setuserId(tokenPayload?.sub)
        } else {
            setuserId(null)
        }
    }, [data?.token])
    const handleOtpInput = (num) => (e) => {
        if (num === 1) {
            setnum1(e.target.value); if (e.target.value.length >= 1) ref2.current.focus();
        } else if (num === 2) {
            setnum2(e.target.value); if (e.target.value.length >= 1) ref3.current.focus();
        } else if (num === 3) {
            setnum3(e.target.value); if (e.target.value.length >= 1) ref4.current.focus();
        } else if (num === 4) {
            setnum4(e.target.value); if (e.target.value.length >= 1) ref5.current.focus();
        } else if (num === 5) {
            setnum5(e.target.value); if (e.target.value.length >= 1) ref6.current.focus();
        } else if (num === 6) { setnum6(e.target.value); }
    }
    useEffect(() => {
        let i = setInterval(() => { setcountdown(c => { return (c - 1) <= 0 ? 0 : c - 1 }) }, 1000)
        return () => { clearInterval(i) }
    }, [])

    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)
    const handleCompleteRegister = async () => {
        // if(checkVIPRequirement()){
        //     alert(checkVIPRequirement())
        //     return
        // }
        // if (!isVerified) {
        //     alert('請先透過發送驗證碼來驗證您的電子郵件')
        //     return
        // }

        if (!validateEmail(data?.email)) {
            alert('電子郵件無效，請重新輸入');
            return
        }
        setisloading(true)


        let checkEmail = await checkIfEmailRegisteredEvent(props.id, data.email)
        if (checkEmail.errno) {
            setisloading(false)
            alert(checkEmail.message || 'error')
            return
        }
        if (checkEmail?.result !== false) {
            setisloading(false)
            alert('該郵箱已經登記過。')
            return
        }
        setisloading(false)




        if (!data.firstname) { alert('請輸入您的名'); return }
        if (!data.lastname) { alert('請輸入您的姓'); return }
        if (form.enableAge && !data.age) { alert('請輸入您的年齡'); return }
        // if( !data.mobile ){ alert('請輸入您的手機號'); return }
        if (form.enableWechat && !data.wechat) { alert('請輸入您的微信號'); return }
        // if( !data.title ){ alert('請選擇您的性別'); return }
        if (!data.email) { alert('請選擇您的電郵'); return }
        if (form.enableHighestDegree && !data.degree) { alert('請輸入您學位'); return }
        // if( !data.school ){ alert('請輸入您的學校及專業'); return }
        // if (form.enableWorkExperience && !data.workEx) { alert('請輸入您的工作經驗'); return }
        // if( !data.employer ){ alert('請輸入您的工作單位名稱及職位'); return }
        // if (form?.enableCurrentEmployer && !data?.company) { alert('請輸入您目前工作單位名稱'); return }
        if (form.enableHongKongVisa && !data.visa) { alert('香港簽證類型'); return }
        if (form.enableGraduationTimeMustFillIn && form.enableGraduationTime && !data.graduationTime) { alert('請輸入您的畢業時間'); return }
        if (form.enableSchoolAndMajorMustFillIn && form.enableSchoolAndMajor && !data.school) { alert('請輸入您的畢業學校及專業'); return }
        if (form.enableAttendanceSession) {
            let hasAtLeastOne = false
            for (let i = 1; i < 40; i++) {
                if (data[`isAttendEvent${i}`]) {
                    hasAtLeastOne = true
                }
            }
            if (!hasAtLeastOne) {
                alert('請選擇出席環節');
                return
            }
        }
        if (form.enableStatement && !data.isAcknowledged) { alert('您必須同意該聲明才能繼續'); return }
        if (data.firstname.length >= 50) { alert('你的名字太長'); return }
        // if(props.id==='68c7658ff79f0cc7cbfa00bb' && (!data?.habitualResidence)){ 
        //     alert('請選擇您的慣常居住地'); 
        //     return 
        // }
        if (form.enableExtraQuestion1 && (data.extraQuestion1 === undefined)) { alert(`請回答: ${form.extraQuestion1}`); return }
        if (form.enableExtraQuestion2 && (data.extraQuestion2 === undefined)) { alert(`請回答: ${form.extraQuestion2}`); return }
        if (form.enableExtraQuestion3 && (data.extraQuestion3 === undefined)) { alert(`請回答: ${form.extraQuestion3}`); return }
        if (form.enableExtraQuestion4 && (data.extraQuestion4 === undefined)) { alert(`請回答: ${form.extraQuestion4}`); return }
        if (form.enableExtraQuestion5 && (data.extraQuestion5 === undefined)) { alert(`請回答: ${form.extraQuestion5}`); return }
        if (form.enableExtraMCQuestion1 && (data.extraMCQuestion1 === undefined)) { alert(`請回答: ${form.extraMCQuestion1}`); return }
        if (form.enableExtraMCQuestion2 && (data.extraMCQuestion2 === undefined)) { alert(`請回答: ${form.extraMCQuestion2}`); return }
        if (form.enableExtraMCQuestion3 && (data.extraMCQuestion3 === undefined)) { alert(`請回答: ${form.extraMCQuestion3}`); return }
        if (form.enableExtraMCQuestion4 && (data.extraMCQuestion4 === undefined)) { alert(`請回答: ${form.extraMCQuestion4}`); return }
        if (form.enableExtraMCQuestion5 && (data.extraMCQuestion5 === undefined)) { alert(`請回答: ${form.extraMCQuestion5}`); return }

        setisloading(true)
        let res = await registerWithEmail(data.email)
        if (res.errno) {
            alert(res.message);
            setisloading(false)
            return
        }
        let token = res?.token?.token
        setData({ ...data, token });

        let json = {
            firstname: data?.firstname,
            lastname: data?.lastname,
        }
        if (data.englishName) json.englishName = data.englishName
        // if(data.title){
        //     json.title=data.title==='男 Male'?'先生':'女士'
        //     json.gender = (data.title==='男 Male')?'男性':'女性'
        // }
        // if(data.gender)json.gender=data.gender
        if (data.dateOfBirthMonth) json.dateOfBirthMonth = data.dateOfBirthMonth
        if (data.dateOfBirthDate) json.dateOfBirthDate = data.dateOfBirthDate
        if (data.position) json.position = data.position
        if (data.degree) json.degree = data.degree
        if (data.company) json.company = data.company
        if (data.school) json.school = data.school
        if (data.workEx) json.workEx = data.workEx
        if (data.age) json.age = data.age
        if (data.visa) json.visa = data.visa
        if (data.cv) json.cv = data.cv
        if (data.title) json.title = data.title
        //business profile
        json.businessProfile = { email: data.email }
        if (data.mobile) json.businessProfile.mobile = data.mobile
        if (data.wechat) json.businessProfile.wechat = data.wechat
        if (data.cv) json.businessProfile.cv = data.cv
        let result = await uploadNewUserProfile(token, json)
        if (result.errno) {
            alert(`${JSON.stringify(result.message || "Error (70007)")}`)
            setisloading(false)
            return
        } else {
            let uploadJSON = {
                age: data?.age,
                wechat: data?.wechat,
                firstname: data?.firstname,
                lastname: data?.lastname,
                email: data?.email,
                mobile: data?.mobile,
                position: data?.position,
                company: data?.company,
                title: data?.title,
                dateOfBirthMonth: data?.dateOfBirthMonth,
                dateOfBirthDate: data?.dateOfBirthDate,
                englishName: data?.englishName,
                isAcknowledged: data?.isAcknowledged || false,
                degree: data?.degree,
                school: data?.school,
                workEx: data?.workEx,
                graduationTime: data?.graduationTime || null,
                visa: data?.visa || null,
                cv: data?.cv || null,
                extraQuestion1: data?.extraQuestion1 || false,
                extraQuestion2: data?.extraQuestion2 || false,
                extraQuestion3: data?.extraQuestion3 || false,
                extraQuestion4: data?.extraQuestion4 || false,
                extraQuestion5: data?.extraQuestion5 || false,
                extraMCQuestion1: data?.extraMCQuestion1 || false,
                extraMCQuestion2: data?.extraMCQuestion2 || false,
                extraMCQuestion3: data?.extraMCQuestion3 || false,
                extraMCQuestion4: data?.extraMCQuestion4 || false,
                extraMCQuestion5: data?.extraMCQuestion5 || false,
                isRegisterTgather: false,
                isRequirePayment: (vipPackage && vipPackage !== 'null') ? true : false,
                vipPackage: (vipPackage && vipPackage !== 'null') ? vipPackage : null,
                isPaid: false,
                //habitualResidence: data?.habitualResidence || null,
            }
            for (let i = 1; i < 40; i++) {
                uploadJSON[`isAttendEvent${i}`] = data[`isAttendEvent${i}`] || false
            }
            let result2 = await participateEvent(token, props.id, uploadJSON)
            if (result2.errno) {
                alert(`${JSON.stringify(result2.message || "Error (70008)")}`)
                setisloading(false)
                return
            } else {
                // if(props.id==='68c7658ff79f0cc7cbfa00bb'&&vipPackage!=='null'&&vipPackage!==null&&vipPackage!==undefined){
                //     navigate(`/purchase/${vipPackage}?userid=${userId||''}`)
                //     return
                // }
                setisShowSuccessfulPage(true)
            }
        }
        setisloading(false)


    }

    const [showChoosePopup, setshowChoosePopup] = useState(null)
    const toggleChoosePopup = (type) => () => {
        if (showChoosePopup === type) setshowChoosePopup(null)
        else
            setshowChoosePopup(type)
    }
    const handleSetWorkEx = (workEx) => () => {
        setData({ ...data, workEx })
        setshowChoosePopup(null)
    }
    const handleSetGender = (gender) => () => {
        setData({ ...data, gender })
        setshowChoosePopup(null)
    }
    const handleSetdateOfBirthMonth = (dateOfBirthMonth) => () => {
        setData({ ...data, dateOfBirthMonth })
        setshowChoosePopup(null)
    }
    const handleSetposition = (val) => () => {
        setData({ ...data, position: val })
        setshowChoosePopup(null)
    }
    const handleSetDegree = (val) => () => {
        setData({ ...data, degree: val })
        setshowChoosePopup(null)
    }
    const handleSetAge = (val) => () => {
        setData({ ...data, age: val })
        setshowChoosePopup(null)
    }
    const handleSetVisa = (val) => () => {
        setData({ ...data, visa: val })
        setshowChoosePopup(null)
    }
    const handleSetHabitualResidence = (val) => () => {
        setData({ ...data, habitualResidence: val })
        setshowChoosePopup(null)
    }
    const handleSetdateOfBirthDate = (dateOfBirthDate) => () => {
        setData({ ...data, dateOfBirthDate })
        setshowChoosePopup(null)
    }
    const getAvailableDate = () => {
        let max = 31
        if (['2'].includes(data?.dateOfBirthMonth)) max = 29
        if (['4', '6', '9', '11',].includes(data?.dateOfBirthMonth)) max = 30
        const valArr = []
        for (let i = 1; i <= max; i++) {
            valArr.push(`${i}`)
        }
        return valArr
    }
    const isReady = () => {
        // if (!isVerified) return false
        if (!data.firstname) return false
        if (!data.lastname) return false
        if (form.enableAge && !data.age) return false
        if (!data.email) return false
        if (form.enableWechat && !data.wechat) return false
        if (form.enableHighestDegree && !data.degree) return false
        // if (form.enableWorkExperience && !data.workEx) return false
        if (form.enableHongKongVisa && !data.visa) return false
        // if (form?.enableCurrentEmployer && !data?.company) return false
        if (form.enableGraduationTimeMustFillIn && form.enableGraduationTime && !data.graduationTime) { return false }
        if (form.enableSchoolAndMajorMustFillIn && form.enableSchoolAndMajor && !data.school) { return false }
        if (form.enableAttendanceSession) {
            let hasAtLeastOne = false
            for (let i = 1; i < 40; i++) {
                if (data[`isAttendEvent${i}`]) hasAtLeastOne = true
            }
            if (!hasAtLeastOne) {
                return false
            }
        }
        if (form.enableStatement && !data.isAcknowledged) { return false }
        if (form.enableExtraQuestion1 && (data.extraQuestion1 === undefined)) { return false }
        if (form.enableExtraQuestion2 && (data.extraQuestion2 === undefined)) { return false }
        if (form.enableExtraQuestion3 && (data.extraQuestion3 === undefined)) { return false }
        if (form.enableExtraQuestion4 && (data.extraQuestion4 === undefined)) { return false }
        if (form.enableExtraQuestion5 && (data.extraQuestion5 === undefined)) { return false }
        if (form.enableExtraMCQuestion1 && (data.extraMCQuestion1 === undefined)) { return false }
        if (form.enableExtraMCQuestion2 && (data.extraMCQuestion2 === undefined)) { return false }
        if (form.enableExtraMCQuestion3 && (data.extraMCQuestion3 === undefined)) { return false }
        if (form.enableExtraMCQuestion4 && (data.extraMCQuestion4 === undefined)) { return false }
        if (form.enableExtraMCQuestion5 && (data.extraMCQuestion5 === undefined)) { return false }

        // if(props.id==='68c7658ff79f0cc7cbfa00bb' && (!data?.habitualResidence)){ return false}
        // if (checkVIPRequirement()) return false
        return true
    }

    const onUploadCV = async (e) => {
        let files = e.target.files;
        if (files.length === 0) {
            alert('請選擇一個文件');
            return;
        }
        if (files.length > 1) {
            alert('只能上傳一個文件');
            return;
        }
        const file = files[0]
        if (!['application/pdf', 'image/png', 'image/jpeg'].includes(file.type)) {
            alert(`文件類型 ${file.type} 不被允許`);
            return;
        }

        if (file.size > 1024 * 1024 * 5) {
            alert('文件大小不能超過5MB');
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        let res = await uploadCV(formData, 'cv', `cv_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}`);
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                setData({ ...data, cv: filepath })
            }
        }
    }

    function countSelectedSessions() {
        let count = 0
        for (let i = 1; i < 40; i++) {
            if (data[`isAttendEvent${i}`]) count++
        }
        return count
    }


    if (!props.id || !form || Object.keys(form).length === 0) {
        return <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ zIndex: 2, backgroundSize: 'cover' }}>
            <div className="text-[24px] font-[700] text-[#000000]">加載中...</div>
            <div className="text-[16px] font-[400] text-[#000000]">Loading...</div>
        </div>
    }

    if (props.allowRegistration === false) {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ zIndex: 2, backgroundSize: 'cover' }}>
                <div className="text-[24px] font-[700] text-[#000000]">報名尚未開始/已結束</div>
                <div className="text-[14px] font-[400] text-[#000000]">Registration has not started / already ended</div>
                <div className="text-[14px] font-[400] text-[#000000]">如有任何查詢，請聯絡我們</div>
                <div className="text-[14px] font-[400] text-[#000000]">
                    If you have any questions, please contact our admin.
                </div>
            </div>
        )
    }

    if (isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center justify-start p-[16px]" style={{ overflowY: 'auto' }}>

            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[64px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1, }} />
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{ zIndex: 2 }}>
                        <div className="font-[700] text-[26px] text-[#000000]">{form.title || ''}</div>
                        <div className="font-[700] text-[26px] text-[#000000]">{form.subtitle || ''}</div>
                        <CompleteSvg width={windowSize.innerWidth <= 1024 ? 140 : 180} />

                        <div className="font-[400] text-[18px] text-[#000000] mt-[16px]">
                            我們衷心期待您的光臨。
                        </div>
                        <div className="font-[400] text-[18px] text-[#000000] mt-[-16px]">
                            以下是您的登記電郵
                        </div>
                        <div className="font-[400] text-[14px] text-[#000000] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.email}
                        </div>
                        <div className="font-[350] text-[16px] text-[#000000] mt-[12px]">
                            您已登記成功，我們正在確認您的信息，並將稍後通過您登記的電郵地址發送入場二維碼給您。
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div className='w-full flex-col items-center relative text-[14px]'>
            <div className='grey-bg w-full flex flex-col items-center relative px-[24px]' style={{ zIndex: 2, backgroundSize: 'cover' }}>
                <div className="relative w-full d-pad-24-m-16 flex flex-col justify-center items-center overflow-hidden max-w-[1300px]">
                    <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1 }} />
                    <div className="flex flex-col w-full items-center gap-[16px]" style={{ zIndex: 2 }}>

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *名<div className="text-[14px]">(Firstname)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.firstname || ''} onChange={onChangefirstname} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                </div>
                            </div>
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *姓<div className="text-[14px]">(Lastname)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.lastname || ''} onChange={onChangelastname} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-[14px] text-[#000000]">請與身份證件上保持一</div>
                        <div className="text-[14px] text-[#000000]">Please keep it the same as on your ID</div> */}
                        {form?.enableAge && <div className="relative w-full flex flex-col items-start gap-[8px] max-w-[800px] py-[8px] d-ml8-m-0" style={{ borderBottom: '1px solid #00000033' }}>
                            <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                *年齡 <div className="text-[14px]">(Age)</div>
                                {/* <div className="text-[14px] text-[#00000033]">(可選填)</div> */}
                            </div>
                            <div onClick={toggleChoosePopup('age')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                <div className="font-[400] text-[16px] flex-1" style={{ color: data?.age ? 'black' : "#00000033" }}>{data?.age || '請選擇'}</div>
                                <DownArrow />
                            </div>
                            {showChoosePopup === 'age' && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col">
                                {AGE.map(item =>
                                    <div onClick={handleSetAge(item)} key={item} className="text-[#000] font-[400] text-[16px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                        {item}
                                    </div>
                                )}
                            </div>}
                        </div>}


                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            {form?.enableMobile && <div className="relative d-flex2-m-100 flex flex-col justify-between gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    手機號 <div className="text-[14px]">(Mobile)</div>
                                </div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 h-full">
                                        <input onChange={onChangeMobile} value={data?.mobile || ''} className="w-full bg-[transparent] border-none" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>}

                            {form?.enableWechat && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-start">
                                    <div style={{whiteSpace: 'nowrap'}} className='flex flex-row items-end'>*微信號 <div className="text-[14px]">(Wechat ID)</div></div> 
                                    <div className='text-[10px] text-[#aaa] ml-[8px] flex'>若沒有微信號，可填寫無(write "None" if you don't have one.)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 h-full">
                                        <input value={data.wechat || ''} onChange={onChangeWechat} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>}
                        </div>

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">*電郵 <div className="text-[14px]">(Email)</div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 h-full">
                                        <input disabled={isVerified} onChange={onChangeEmail} value={data?.email || ''} className="w-full bg-[transparent] border-none" placeholder="請填寫" />
                                    </div>
                                </div>
                                {showRegisterError &&
                                    <div className="text-[red] font-[400] text-[14px] flex flex-row items-left w-full max-w-[800px] ">
                                        {showRegisterError}
                                    </div>
                                }
                            </div>

                            {form?.enableHighestDegree && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *您的最高學位<div className="text-[14px]">(Your highest degree)</div>
                                </div>

                                {[undefined, '學士 Bachelor', '碩士 Master', '博士 Doctor', ''].includes(data?.degree) && <div onClick={toggleChoosePopup('degree')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[14px] flex-1" style={{ color: data?.degree ? 'black' : "#00000033" }}>{data?.degree || '請選擇'}</div>
                                    <DownArrow />
                                </div>}
                                {showChoosePopup === 'degree' && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col max-h-[200px] overflow-auto border border-[#ccc]" >
                                    {EDU.map(item =>
                                        <div onClick={handleSetDegree(item === '其他Other' ? '' : item)} key={item} className="text-[#000] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                                {!['學士 Bachelor', '碩士 Master', '博士 Doctor', undefined, ''].includes(data?.degree) && <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data?.degree || ''} onChange={e => onChangeDegree(e)} className="flex-1 bg-[transparent]" placeholder="請填寫" />
                                </div>}
                            </div>}
                        </div>

                        {/* {form?.enableGraduationTime && <div className="w-full flex flex-row max-w-[800px] flex-wrap gap-[8px]">
                        <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                            <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                {form?.enableGraduationTimeMustFillIn ? '*' : ''}畢業時間<div className="text-[14px]">(Graduation time)</div>
                            </div>

                            <div className="flex flex-row w-full gap-[24px]">
                                <input value={data.graduationTime || ''} onChange={onChangeGraduationTime} className="flex-1 bg-[transparent] border-none" placeholder="DD/MM/YYYY" />
                            </div>
                        </div>
                    </div>} */}

                        <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            {form?.enableSchoolAndMajor && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    {form?.enableSchoolAndMajorMustFillIn ? '*' : ''}畢業學校及專業<div className="text-[14px]">(School and major)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.school || ''} onChange={onChangeSchoolMajor} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                </div>
                            </div>}

                            {form?.enableWorkExperience && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px] d-ml8-m-0" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    您的工作經驗 <div className="text-[14px]">(Your work experience)</div>
                                    {/* <div className="text-[14px] text-[#00000033]">(可選填)</div> */}
                                </div>
                                <div onClick={toggleChoosePopup('workEx')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[14px] flex-1" style={{ color: data?.workEx ? 'black' : "#00000033" }}>{data?.workEx || '請選擇'}</div>
                                    <DownArrow />
                                </div>
                                {showChoosePopup === 'workEx' && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col border border-[#ccc] max-h-[200px] overflow-auto">
                                    {WORKEX.map(item =>
                                        <div onClick={handleSetWorkEx(item)} key={item} className="text-[#000] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                            </div>}
                        </div>
                        <div className="w-full flex flex-row max-w-[800px] flex-wrap gap-[8px]">
                            {form?.enableCurrentEmployer && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    目前工作單位名稱<div className="text-[14px]">(Current employer)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.company || ''} onChange={onChangecompany} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                </div>
                            </div>}
                            {form?.enablePosition && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    職位<div className="text-[14px]">(position)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px]">
                                    <input value={data.position || ''} onChange={onChangePosition} className="flex-1 bg-[transparent] border-none" placeholder="請填寫" />
                                </div>
                            </div>}
                        </div>


                        <div className="w-full flex flex-row max-w-[800px] flex-wrap gap-[8px]">
                            {form?.enableCurrentEmployer && <div className="relative d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *您的身份類型 <div className="text-[14px]">(Your identity type)</div>
                                    {/* <div className="text-[14px] text-[#00000033]">(可選填)</div> */}
                                </div>
                                <div className='w-full flex relative'>
                                <div onClick={toggleChoosePopup('visa')} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[14px] flex-1" style={{ color: data?.visa ? 'black' : "#00000033" }}>{data?.visa || '請選擇'}</div>
                                    <DownArrow />
                                </div>
                                {showChoosePopup === 'visa' && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col max-h-[300px] overflow-auto border border-[#ccc]">
                                    {VISA.map(item =>
                                        <div onClick={handleSetVisa(item)} key={item} className="text-[#000] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                                </div>
                            </div>}
                            {form?.enableUploadCV && <div className="relative d-flex2-m-100 flex flex-col items-start pt-[8px] pb-[2px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    上傳履歷表 <div className="text-[14px]">(Upload CV)</div>  <span className="text-[10px] text-[#00000033] ml-[8px]">可選填 (Optional)</span>
                                </div>
                                <div className="text-[#000000] font-[400] text-[10px] flex opacity-[0.7]" style={{whiteSpace:'pre-line'}}>
                                    如出席人才交流大會，上傳簡歷將有助於我們為您推薦合適的職位Your resume will help us recommend positions for you.
                                </div>
                                <div className="flex flex-row w-full justify-between items-center">
                                    <input type="file" onChange={onUploadCV} className="bg-[transparent] border-none rounded-[0px] mt-[4px]" placeholder="請選擇檔案" />
                                </div>
                            </div>}
                        </div>





                        {[1, 2, 3, 4, 5]?.map((q, qi) =>
                            form?.[`enableExtraQuestion${q}`] ? <div key={qi} className="relative w-full  max-w-[800px] flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    {form?.[`extraQuestion${q}`] || ''}
                                </div>
                                <div onClick={toggleChoosePopup(`extraQuestion${q}`)} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[16px] flex-1" style={{ color: data?.[`extraQuestion${q}`] ? 'black' : "#00000033" }}>{data?.[`extraQuestion${q}`] || '請選擇'}</div>
                                    <DownArrow />
                                </div>
                                {showChoosePopup === `extraQuestion${q}` && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col max-h-[200px] overflow-auto" >
                                    {['是', '否'].map(item =>
                                        <div onClick={() => {
                                            setData({ ...data, [`extraQuestion${q}`]: item })
                                            setshowChoosePopup(null)
                                        }} key={item} className="text-[#000] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                            </div>
                                : null
                        )}
                        {[1, 2, 3, 4, 5]?.map((q, qi) =>
                            form?.[`enableExtraMCQuestion${q}`] ? <div key={qi} className="relative w-full  max-w-[800px] flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    {form?.[`extraMCQuestion${q}`] || ''}
                                </div>
                                <div onClick={toggleChoosePopup(`extraMCQuestion${q}`)} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[14px] flex-1" style={{ color: data?.[`extraMCQuestion${q}`] ? 'black' : "#00000033" }}>{data?.[`extraMCQuestion${q}`] || '請選擇'}</div>
                                    <DownArrow />
                                </div>
                                {showChoosePopup === `extraMCQuestion${q}` && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col max-h-[200px] overflow-auto" >
                                    {form?.[`extraMCQuestion${q}Options`]?.split(',').map(item =>
                                        <div onClick={() => {
                                            setData({ ...data, [`extraMCQuestion${q}`]: item })
                                            setshowChoosePopup(null)
                                        }} key={item} className="text-[#000] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {item}
                                        </div>
                                    )}
                                </div>}
                            </div>
                                : null
                        )}

                        {form.enableAttendanceSession && <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *出席環節 <div className="text-[14px]">(Attendance Session)</div>
                                    <div className="text-[14px] text-[#00000033] d-flex-m-hidden">(可多選Multiple choices)</div>
                                </div>
                                <div className="text-[14px] text-[#00000033] d-hidden-m-flex">(可多選Multiple choices)</div>
                                {form?.attendanceSessions?.map((item, index) =>
                                    <div key={index} className="flex flex-row w-full gap-[24px]">
                                        <input type="checkbox" checked={data?.[`isAttendEvent${Number(index) + 1}`] || false} onChange={(e) => { setData({ ...data, [`isAttendEvent${Number(index) + 1}`]: !data?.[`isAttendEvent${Number(index) + 1}`] }) }} />
                                        {Number(index) + 1}.{item?.name || ''}
                                    </div>
                                )}
                            </div>
                        </div>}


                        {form.enableStatement && <div className="w-full flex flex-row max-w-[800px] flex-wrap">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                                <div className="text-[#000000] font-[400] text-[14px] flex flex-row items-end">
                                    *聲明 <div className="text-[14px]">(Statement)</div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px] text-[11px]">
                                    <input type="checkbox" checked={data?.isAcknowledged || false} onChange={(e) => { setData({ ...data, isAcknowledged: !data.isAcknowledged }) }} />
                                    {form?.statement || ''}
                                </div>
                            </div>
                        </div>}

                        <div onClick={handleCompleteRegister} className="max-w-full mt-[16px] cursor-pointer flex justify-center items-center text-black text-[14px] font-[700] rounded-[99px] px-[24px] py-[12px]" style={{ border: '1px solid black', opacity: isReady() ? 1 : .5 }}>
                            提交 (Upload)
                        </div>

                    </div>
                </div>
            </div>
            {
                isShowOtpPopup && <div className="fixed top-0 bottom-0 left-0 right-0 bg-[#00000070] flex items-center justify-center p-[16px] z-[3]">
                    <div className="flex flex-col w-full max-w-[800px] bg-[#fff] rounded-[24px] d-px64-m-px-16 py-[32px] justify-center items-center" style={{ boxSizing: 'border-box' }}>
                        <div className="text-[#000000] text-[32px] font-[700]">驗證</div>
                        <div className="flex flex-row text-[#938474] font-[400] text-[16px] w-full text-left mt-[64px]">
                            驗證碼已發送至
                            <div className="ml-[16px] font-[700] d-flex-m-hidden">{data?.email || ''}</div>
                        </div>
                        <div className="font-[700] d-hidden-m-flex text-[#938474] text-[14px] text-left w-full">{data?.email || ''}</div>

                        <div className='w-full flex flex-row justify-start mt-5 ' style={{ gap: 8, boxSizing: 'border-box' }}>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num1} onChange={handleOtpInput(1)} ref={ref1} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num2} onChange={handleOtpInput(2)} ref={ref2} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num3} onChange={handleOtpInput(3)} ref={ref3} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num4} onChange={handleOtpInput(4)} ref={ref4} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num5} onChange={handleOtpInput(5)} ref={ref5} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                            <div className='flex-[1]' style={{ height: undefined, aspectRatio: 1, }}>
                                <input value={num6} onChange={handleOtpInput(6)} ref={ref6} className='w-full h-full text-[32px] text-center' maxLength={1} style={{ borderColor: '#8D876C', borderWidth: .5, borderRadius: 8, boxSizing: 'border-box' }} />
                            </div>
                        </div>

                        {/* <div className='flex flex-row w-full items-center justify-between mt-5'>
                        {countdown > 0
                            ? <div className='text-[#949494] text-[14px]'>{countdown}秒後重新發送</div>
                            : <div onClick={onRequestOtp} className='underline text-[14px] text-[#000000] cursor-pointer'>重新發送</div>
                        }
                    </div> */}

                        <div onClick={handleLoginButton} className="d-flex-m-hidden h-[72px] bg-[#0F737E] w-full rounded-[99px] text-white text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[64px]">
                            確認
                        </div>
                        <div onClick={cancelOtp} className="d-flex-m-hidden h-[72px] bg-[#fff] w-full rounded-[99px] text-[#0F737E] text-[24px] font-[500] text-center flex items-center justify-center cursor-pointer mt-[4px]">
                            取消
                        </div>

                    </div>
                </div>
            }

            {isloading && <LoadingPage />}
        </div >
    );
};



const GroupForm = ({ scrollRef, handleSetRightNav }) => {
    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() { const { innerWidth, innerHeight } = window; return { innerWidth, innerHeight }; }
    useEffect(() => {
        function handleWindowResize() { setWindowSize(getWindowSize()); }
        window.addEventListener('resize', handleWindowResize);
        return () => { window.removeEventListener('resize', handleWindowResize); };
    }, [])
    
    const templateId = '68ca51d3c75bbde57c85333d'
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const [isInitialized, setisInitialized] = useState(false);

    async function fetchDate() {
        setisloading(true)
        let result = await fetchRegistrationFormTemplateById(templateId);
        if (result?.result) {
            setData(result.result);
            setisInitialized(true);
        } else {
            setData({});
            alert('無法獲取報名表資料，請稍後再試。')
        }
        setisloading(false)
    }
    useEffect(() => {
        if (templateId.length === 24) {
            fetchDate()
        }
    }, [templateId])

    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)

    const handleSubmit = async () => {
        for (let i = 0; i < (data?.questions || []).length; i++) {
            let q = data?.questions[i]
            if (q?.isRequired && (!q?.answer || q?.answer.length === 0)) {
                alert(`請回答必答問題: ${q?.question || ''}`)
                return
            }
            if (q.type === '電子郵件' && q?.answer && q?.answer.length > 0) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(q.answer)) {
                    alert(`請輸入正確的電郵地址: ${q?.question || ''}`)
                    return
                }
            }
        }
        let json = {
            templateId,
            questions: data?.questions || [],
            email: (data?.questions || []).find(q => q.type === '電子郵件')?.answer?.trim()?.toLowerCase() || '',
        }
        setisloading(true)
        let result = await insertRegistrationForm(json)
        setisloading(false)
        if (result?.errno === 0) {
            setisShowSuccessfulPage(true)
        } else {
            alert(result?.message || '提交失敗，請稍後再試。')
        }
    }

    useEffect(() => {
        console.log(data)
    }, [data])

    const onUploadCV = (q, qi) => async (e) => {
        let files = e.target.files;
        if (files.length === 0) {
            alert('請選擇一個文件');
            return;
        }
        if (files.length > 1) {
            alert('只能上傳一個文件');
            return;
        }
        const file = files[0]
        if (!['application/pdf', 'image/png', 'image/jpeg'].includes(file.type)) {
            alert(`文件類型 ${file.type} 不被允許`);
            return;
        }

        if (file.size > 1024 * 1024 * 5) {
            alert('文件大小不能超過5MB');
            return
        }

        setisloading(true)
        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        let res = await uploadCV(formData, 'cv', `cv_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}`);
        setisloading(false)
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                let questions = data?.questions || []
                questions[qi].answer = filepath
                setData({ ...data, questions })
            }
        }
    }

    const [showChoosePopup, setshowChoosePopup] = useState(null)
    if (!isInitialized) {
        return <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ zIndex: 2, backgroundSize: 'cover' }}>
            <div className="text-[24px] font-[700] text-[#000000]">加載中...</div>
            <div className="text-[16px] font-[400] text-[#000000]">Loading...</div>
        </div>
    }

    if (data.status !== 'published') {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ zIndex: 2, backgroundSize: 'cover' }}>
                <div className="text-[24px] font-[700] text-[#000000]">報名尚未開始/已結束</div>
                <div className="text-[16px] font-[400] text-[#000000]">Registration has not started / already ended</div>
                <div className="text-[16px] font-[400] text-[#000000]">如有任何查詢，請聯絡我們</div>
                <div className="text-[16px] font-[400] text-[#000000]">
                    If you have any questions, please contact our admin.
                </div>
            </div>
        )
    }

    if (isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center justify-start p-[16px]" style={{ overflowY: 'auto' }}>

            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[32px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ zIndex: 1, }} />
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{ zIndex: 2 }}>
                        <div className='font-bold text-[26px] mb-[16px]'>
                            {data?.name || '報名成功！'}
                        </div>

                        <CompleteSvg width={windowSize.innerWidth <= 1024 ? 140 : 180} />

                        <div className="font-[400] text-[20px] text-[#000000] mt-[16px]">
                            感謝您的登記！
                        </div>
                        {/* <div className="font-[400] text-[18px] text-[#000000] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.questions?.find(q=>q.type==='電子郵件')?.answer||'-'}
                        </div> */}
                        <div className="font-[350] text-[18px] text-[#000000] mt-[12px]">
                            您已登記成功，我們正在確認您的信息，並將於稍後時間與您聯繫。
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div className='w-full flex-col items-center flex relative text-[14px] p-[24px] pt-[16px]'>
            <div className='grey-bg w-full flex flex-row items-stretch justify-start relative flex-wrap max-w-[800px]' style={{ zIndex: 2, backgroundSize: 'cover',boxSizing:'border-box' }}>
                {data?.questions?.map((q, qi) =>
                    <div key={qi} className='bg-[white] p-[12px] mb-[12px] flex flex-col d-50-m-100 px-[4px]' style={qi===data?.questions.length - 1  ? { minWidth: '100%' } : { }}>
                        <div className='w-full flex flex-col h-full' style={qi===data?.questions.length - 1 && qi % 2 === 0 ? { } : {borderBottom:'1px solid #ccc' }}>
                            <div className='text-[#000000] font-[400] text-[14px] flex flex-row items-start'>
                                <div style={{whiteSpace:'nowrap'}}>{q?.question || ''}{q?.isRequired && <span className='text-[#E74C3C]'>*</span>} </div>
                                {q.hint ? <div className='text-[#aaa] font-[400] text-[10px] ml-[8px]'>{q?.hint || ''}</div> : <></>}
                            </div>
                            {/*'文字問題', '單選題', '電子郵件'*/}
                            {q.type === '文字問題' &&
                                <input type='text' className='mt-[8px] p-[8px]' style={{borderRadius:'0px',border:'none'}} placeholder='請輸入文字' onChange={(e) => {
                                    let questions = data?.questions || []
                                    questions[qi].answer = e.target.value
                                    setData({ ...data, questions })
                                }} />
                            }
                            {q.type === '電子郵件' &&
                                <input type='email' className='mt-[8px] border border-[#ccc] rounded-[6px] p-[8px]' placeholder='請輸入電郵地址' onChange={
                                    (e) => {
                                        let questions = data?.questions || []
                                        questions[qi].answer = e.target.value
                                        setData({ ...data, questions })
                                    }
                                } />
                            }
                            {q.type === '上傳履歷表' && <div className='flex flex-col mt-[8px]' style={{ gap: 8 }}>
                                <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>

                                    <div className="flex flex-row w-full gap-[24px]">
                                        <input type="file" onChange={onUploadCV(q, qi)} className="flex-1 bg-[transparent] border-none rounded-[0px]" placeholder="請選擇檔案" />
                                    </div>
                                </div>
                            </div>}

                            {q.type === '單選題' && q.options.length !== 1 && <div className="relative w-full flex flex-col flex-1 justify-end items-start gap-[8px] py-[8px]" style={{ }}>

                                <div onClick={() => { setshowChoosePopup(`popup-${qi}`) }} className="flex flex-row w-full gap-[24px] items-center cursor-pointer">
                                    <div className="font-[400] text-[14px] flex-1" style={{ color: q?.answer ? 'black' : "#00000033" }}>{q?.answer || '請選擇'}</div>
                                    <DownArrow />
                                </div>
                                {showChoosePopup === `popup-${qi}` && <div className="absolute w-full top-[100%] z-[10] bg-white flex flex-col border border-[#ccc] max-h-[400px] overflow-auto" >
                                    {q?.options?.length > 0 && q?.options.map((option, oi) =>
                                        <div onClick={() => {
                                            let questions = data?.questions || []
                                            questions[qi].answer = option
                                            setData({ ...data, questions })
                                            setshowChoosePopup(null)
                                        }} key={option} className="text-[#000] text-[10px] font-[400] text-[14px] hover:font-[700] cursor-pointer px-[24px] py-[8px]">
                                            {option}
                                        </div>
                                    )}
                                </div>}
                                {q?.answer?.includes('其他') &&
                                    <input type='text' className='border border-[#ccc] rounded-[6px] p-[4px] bg-[#eee]' placeholder='請輸入其他內容' onChange={
                                        (e) => {
                                            let questions = data?.questions || []
                                            questions[qi].answer = `其他: ${e.target.value}`
                                            setData({ ...data, questions })
                                        }
                                    } />}
                            </div>}


                            {q.type === '單選題' && q.options.length === 1 &&
                                <div className='relative flex flex-col mt-[8px]' style={{ gap: 8 }}>
                                    {q?.options?.length > 0 ? q?.options?.map((option, oi) =>
                                        option === '其他' ?
                                            <div key={oi} className='flex flex-row items-center gap-[8px]'>
                                                <input type='radio' name={`question-${qi}`} value={option} onChange={
                                                    (e) => {
                                                        let questions = data?.questions || []
                                                        questions[qi].answer = e.target.value
                                                        setData({ ...data, questions })
                                                    }
                                                } />
                                                <span className='text-[#000000]'>{option}</span>
                                                {q?.answer?.includes('其他') &&
                                                    <input type='text' className='border border-[#ccc] rounded-[6px] p-[4px]' placeholder='請輸入其他內容' onChange={
                                                        (e) => {
                                                            let questions = data?.questions || []
                                                            questions[qi].answer = `其他: ${e.target.value}`
                                                            setData({ ...data, questions })
                                                        }
                                                    } />}
                                            </div>
                                            :
                                            <label key={oi} className='flex flex-row items-center gap-[8px]'>
                                                <input type='radio' name={`question-${qi}`} value={option} onChange={
                                                    (e) => {
                                                        let questions = data?.questions || []
                                                        questions[qi].answer = e.target.value
                                                        setData({ ...data, questions })
                                                    }
                                                } />
                                                <span className='text-[#000000]'>{option}</span>
                                            </label>
                                    ) : <div className='text-[#E74C3C]'>此題無選項，請聯絡我們。</div>}
                                </div>
                            }
                        </div>
                    </div>
                )}
            </div>
            <div onClick={handleSubmit} className="max-w-full mt-[16px] cursor-pointer flex justify-center items-center text-black text-[14px] font-[700] rounded-[99px] px-[24px] py-[12px]" style={{ border: '1px solid black' }}>
                提交 (Upload)
            </div>

            

            {isloading && <LoadingPage />}

        </div>
    )

};

export default Page;